<template>
  <nav class="breadcrumbs">
    <ul>
      <li>
        <span class="dis-ib">
          <a href="/">{{ siteName }}</a>
        </span>
      </li>
      <li v-for="breadcrumb in breadcrumbs" v-if="breadcrumb.href">
        <span>&gt;</span><span><a :href="breadcrumb.href">{{ breadcrumb.label }}</a></span>
      </li>
      <li v-else>
        <span>&gt;</span><span class="fwb">{{ breadcrumb.label }}</span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'breadcrumbs-common',
  props: {
    defaultBreadcrumbs : {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      siteName: document.querySelector('meta[name="site-name"]').getAttribute('content'),
      breadcrumbs: this.defaultBreadcrumbs.length ? this.defaultBreadcrumbs : JSON.parse(document.querySelector('meta[name="breadcrumbs"]').getAttribute('content'))
    }
  }
}
</script>